import { j as e } from "../../../../jsx-runtime.BREq8dyb.js";
import { UploadWorkerApi as o } from "@decentriq/uploader";
import { Box as c } from "@mui/joy";
import { memo as y, useState as p, useEffect as k, useMemo as m } from "react";
import { useErrorBoundary as W } from "react-error-boundary";
import g, { PromiseState as x } from "../../../Loader/Loader.js";
import "../../contexts/DatasetContext/DatasetContext.js";
import "../../contexts/FeatureContext/FeatureContext.js";
import "../../contexts/FileContext/FileContext.js";
import "../../contexts/IntrospectionContext/IntrospectionContext.js";
import "../../contexts/NavigatorContext/NavigatorContext.js";
import "../../contexts/OptionsContext/OptionsContext.js";
import "../../contexts/SchemaContext/SchemaContext.js";
import "../../contexts/TypificationContext/TypificationContext.js";
import { WorkerProvider as h } from "../../contexts/WorkerContext/WorkerContext.js";
import "../../helpers/uploadWorker.js";
import j from "../../helpers/uploadWorkerPromise.js";
const w = y(({
  name: i,
  children: l
}) => {
  const {
    showBoundary: a
  } = W(), [t, n] = p(!1), [r, d] = p(void 0);
  k(() => {
    !t && !(r instanceof o) && (async () => {
      n(!0);
      try {
        const s = new o(await j(i));
        d(s);
      } catch {
        a(new Error("Failed to initialize uploader"));
      } finally {
        n(!1);
      }
    })();
  }, [t, i, a, r]);
  const f = m(() => {
    if (r instanceof o)
      return r.analyzeDataset.bind(r);
  }, [r]), u = m(() => {
    if (r instanceof o)
      return r.uploadDataset.bind(r);
  }, [r]);
  return !t && r instanceof o ? /* @__PURE__ */ e.jsx(h, { value: {
    analyzeDataset: f,
    uploadDataset: u
  }, children: l }) : /* @__PURE__ */ e.jsx(c, { sx: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    width: "100%"
  }, children: /* @__PURE__ */ e.jsx(g, { loadLabel: "Initializing dataset engine…", loadState: x.Pending }) });
});
w.displayName = "WorkerContainer";
export {
  w as default
};
//# sourceMappingURL=WorkerContainer.js.map
